import { axios } from "@/services/api"
import { rei } from "@/services/api"

class SofiaSignerService {
  static exec (action, params = {}) {
    return axios.get(`${this.endpoint}/${action}`, {
      params
    })
  }

  static execPost (action, data = {}) {
    return axios.post(`${this.endpoint}/${action}`, data)
  }

  static async verificaConexao ({ force } = {}) {
    try {
      return await this.exec('handshake')
    } catch (e) {
      throw Error('Não foi possível estabalecer uma conexão com o SofiaSigner')
    }
  }

  static async obterCertificados () {
    let certificados = []

    try {
      const response = await this.exec('certificados')
      certificados = response.data
    } catch (e) {
      throw Error('Ocorreu um problema ao tentar obter os certificados')
    }

    if (certificados.length === 0) {
      throw Error('Não foi possível encontrar o certificado')
    }

    return certificados
  }

  static autenticar (posicaoCertificado) {
    const data = {
      posicaoCertificado
    }

    return this.execPost('login', data)
  }

  static assinarP7S (posicaoCertificado, conteudo, callbackData, callbackUrl) {
    callbackUrl = callbackUrl || rei.defaults.baseURL + '/upload-p7s'

    const data = {
      posicaoCertificado,
      conteudo,
      callbackUrl,
      callbackData
    }

    return this.execPost('assinar-p7s', data)
  }
}

SofiaSignerService.endpoint = 'http://localhost:8713'

export default SofiaSignerService
